import React, { useEffect, useState } from 'react';
import FilterComponents from '../../../product/components/FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import leoImg from './../../../../assets/images/Leo.png'
import axios from 'axios';

function EmployeeSetupPage(props) {
    const columns = [
        { field: 'userName', headerName: 'User Name', align: 'center', headerAlign: 'center', flex: 1 },
        { field: 'email', headerName: 'Email Address', align: 'center', headerAlign: 'center', flex: 1 },
        { field: 'contactNumber', headerName: 'Contact Number', align: 'center', headerAlign: 'center', flex: 1 },
        { field: 'designations', headerName: 'Designations', align: 'center', headerAlign: 'center', flex: 1 }

    ];

    const [dataRows, setDataRows] = useState([])
    // [
    //     { id: 1, checkbox: '', firstName: 'Leo', lastName: 'Leo', userName: 'Leo', Designations: 'General Manager', RestaurantName: "Pot Kettle Black London", ContactNumber: "098951685461", Address: "London", DOB: "19-may-2023" },
    //     { id: 2, checkbox: '', firstName: 'Leo', lastName: 'Leo', userName: 'Leo', Designations: 'General Manager', RestaurantName: "Pot Kettle Black London", ContactNumber: "098951685461", Address: "London", DOB: "19-may-2023" },
    // ];
    const apiAddress = process.env.REACT_APP_SECRET;
    useEffect(() => {
        const token = JSON.parse(localStorage.getItem('restaurant'));
        axios({
            method: 'get',
            url: apiAddress + '/api/Employee/' + token.id,
        })
            .then((response) => {
                console.log(response)
                var list = [];
                response.data.map((dt, i) => {
                    var obj = {
                        id: dt.id,
                        userName: dt.userName,
                        email: dt.eMail,
                        contactNumber: dt.phoneNumber,
                        designations: dt.restaurantEmployeeRank
                    }
                    list.push(obj);
                })
                setDataRows(list);
            })
            .catch((error) => {

            });
    }, [])

    return (
        <div>

            <FilterComponents title={"OK"} isItem={3} />
            <CustomDataGrid columns={columns} dataRows={dataRows} />
        </div>
    );
}

export default EmployeeSetupPage;